//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.RouteObject.js";
let d=[[[0,"NxEquivalent",1,"NXObject",0],[0,"PartName",1,0],[0,"PartNumber",1,0]],[[["no_of_route_device_relshps"],"GetReferencingDeviceRelshps",{R_:{route_device_relshps:"Routing.DeviceRelationship[]"}},0,0],[["no_of_related_single_devices"],"GetRelatedSingleDevices",{R_:{related_single_devices:"Routing.SingleDevice[]"}},0,0],[[],"GetRelatingSingleDevice",{R_:{relating_single_device:"Routing.SingleDevice"}},0,0],[["no_of_route_implemented_connections"],"GetImplementedConnections",{R_:{route_implemented_connections:"Routing.LogicalConnection[]"}},0,0],[[],"ManuallyDelete",{R_:{elec_delete_object_result:''}},0,0],[[],"GetItemDefinition",{R_:{route_item_definition:"Routing.ItemDefinition"}},0,0]],[]];
SPLM.Routing.SingleDevice = class extends SPLM.Routing.RouteObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.SingleDevice";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.SingleDevice.DeleteObjectResult = Object.freeze({
    "Ok" : "Ok", "StillRouted" : "StillRouted", "StillAssigned" : "StillAssigned", "CantDeleteUnknown" : "CantDeleteUnknown"});

export default SPLM;